<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col lg="6" class="tab-details-el" v-if="nrOfGuests">
          <md-list>
            <md-list-item>
              <md-icon>person</md-icon>
              <div class="md-list-item-text">
                <span>{{nrOfGuests}} {{i18n_local.people | capitalize}}</span>
              </div>
            </md-list-item>
          </md-list>
        </b-col>
        <b-col lg="6" class="tab-details-el" v-if="notEmpty(nrOfBedrooms)">
          <md-list>
            <md-list-item>
              <md-icon>airline_seat_individual_suite</md-icon>
              <div class="md-list-item-text">
                <span>{{nrOfBedrooms}} {{i18n_local.bedroom | capitalize}}</span>
              </div>
            </md-list-item>
          </md-list>
        </b-col>
        <b-col lg="6" class="tab-details-el" v-if="notEmpty(nrOfBathrooms)">
          <md-list>
            <md-list-item>
              <md-icon>grain</md-icon>
              <div class="md-list-item-text">
                <span>{{nrOfBathrooms}} {{i18n_local.bathroom | capitalize}}</span>
                <span v-if="wcAndBathSeparated">{{i18n_local.separate_wc_and_bath | capitalize}}</span>
              </div>
            </md-list-item>
          </md-list>
        </b-col>
        <b-col lg="6" class="tab-details-el" v-if="notEmpty(nrOfBalconiesTotalCalculated)">
          <md-list>
            <md-list-item>
              <md-icon>brightness_5</md-icon>
              <div class="md-list-item-text">
                <span>{{nrOfBalconiesTotalCalculated}} {{i18n_local.balcony | capitalize}}</span>
                <span>{{balconyIfExists}}</span>
              </div>
            </md-list-item>
          </md-list>
        </b-col>
        <b-col lg="6" class="tab-details-el" v-if="notEmpty(nrOfStoragesTotalCalculated)">
          <md-list>
            <md-list-item>
              <md-icon>storage</md-icon>
              <div class="md-list-item-text">
                <span>{{nrOfStoragesTotalCalculated}} {{i18n_local.store_room | capitalize}}</span>
                <span>{{allStoragesIfExists}}</span>
              </div>
            </md-list-item>
          </md-list>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
<script>
import { getTextValueFromObjectUsingValue } from "../../searchFunctions.js";
import { mapGetters } from "vuex";
const lists = require("@/lists.js");
export default {
  props: {
    listing: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      balconyIfExists: undefined,
      allStoragesIfExists: undefined,
      nrOfBalconiesTotalCalculated: undefined,
      nrOfStoragesTotalCalculated: undefined,
      balconyList: lists.balconyTypeList,
      storageList: lists.storageTypeList,
      nrOfGuests: undefined,
      nrOfBedrooms: undefined,
      nrOfBathrooms: undefined,
      wcAndBathSeparated: undefined,
      storage: undefined,
      balcony: undefined
    };
  },
  filters: {
    capitalize: function(value) {
        if (!value) return "";
        value = value.toString();
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    getPersonDisplayValue(){
        if (!this.nrOfGuests) return "";
        if (this.nrOfGuests == 1) return this.i18n_local.person;
        else return this.i18n_local.people;
    }
  },
  created() {
    this.mapListingToCapacityVariables(this.listing);
  },
  methods: {
    mapListingToCapacityVariables(listing) {
      this.nrOfGuests = listing.techDet.nrOfGuests;
      this.nrOfBedrooms = listing.techDet.nrOfBedrooms;
      this.nrOfBathrooms = listing.techDet.nrOfBathrooms;
      this.wcAndBathSeparated = listing.techDet.wcAndBathSeparated === "true"; /// return 'true'(boolean) if wcAndBathSeparated = 'true'(string)
      this.storage = listing.techDet.storage;
      this.balcony = listing.techDet.balcony;

      this.balconyIfExists = "";
      for (var i = 0; i < this.balcony.length; i++) {
        this.balconyIfExists =
          this.balconyIfExists +
          getTextValueFromObjectUsingValue(
            this.balconyList,
            this.balcony[i].category
          ) +
          " " +
          this.balcony[i].areaM2 +
          "\u33A1";
      }
      this.allStoragesIfExists = "";
      for (var i = 0; i < this.storage.length; i++) {
        if (i == 0)
          this.allStoragesIfExists = getTextValueFromObjectUsingValue(
            this.storageList,
            this.storage[i]
          );
        else
          this.allStoragesIfExists =
            this.allStoragesIfExists +
            ", " +
            getTextValueFromObjectUsingValue(this.storageList, this.storage[i]);
      }
      this.nrOfBalconiesTotalCalculated = this.balcony.length;
      this.nrOfStoragesTotalCalculated = this.storage.length;
    },
    notEmpty(content) {
      if(!content) return false
      if (Array.isArray(content)) return content.length > 0;
      else if (content) return true;
      else return false;
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
@import "../../assets/styles/listing-preview.css";
</style>


// WEBPACK FOOTER //
// src/components/listingComponents/propertyCapacityPreview.vue